import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { Button } from '~/components/ui/button';

export function NotFoundScreen(): React.ReactNode {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-6 text-center">
        <p className="text-8xl font-semibold tracking-tight text-border select-none">404</p>
        <div className="flex flex-col gap-2">
          <h1 className="text-2xl font-semibold tracking-tight">{t('notFound.title')}</h1>
          <p className="text-sm text-muted-foreground">{t('notFound.description')}</p>
        </div>
        <Button>
          <Link to="/jobs">{t('notFound.goHome')}</Link>
        </Button>
      </div>
    </div>
  );
}
